module.exports = __webpack_public_path__ + "static/media/file-downloading-error.a2cae93d.svg";